import React from 'react';

const LABELS = {
  draft: 'Draft',
  scheduled: 'Scheduled',
  published: 'Published',
  archived: 'Archived',
};

/**
 * Pill badge. `state` picks the colour: a page state (draft | scheduled |
 * published | archived) or a semantic one (warn | danger | success | info).
 *   <Badge state="published" />           -> "Published"
 *   <Badge state="danger">Spam</Badge>    -> custom label
 */
export default function Badge({ state, children, title }) {
  const key = String(state || '').toLowerCase();
  const cls = key ? `badge badge-${key}` : 'badge';
  return (
    <span className={cls} title={title}>
      {children ?? LABELS[key] ?? state}
    </span>
  );
}
